import { render, staticRenderFns } from "./video.vue?vue&type=template&id=b682c32a&scoped=true"
import script from "./video.vue?vue&type=script&lang=js"
export * from "./video.vue?vue&type=script&lang=js"
import style0 from "./video.vue?vue&type=style&index=0&id=b682c32a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b682c32a",
  null
  
)

export default component.exports